import React, { useLayoutEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';

const Popover = ({ anchorRef, title, content, open = true, offsetX = 0, offsetY= 0, placement = 'top-start' }) => {
  const [style, setStyle] = React.useState({ visibility: 'hidden' });

  useLayoutEffect(() => {
    if (!open) return;
    // Place relative to the wrapper (which has position: relative)
    if (placement === 'bottom-start') {
      setStyle({
        position: 'absolute',
        top: `calc(100% + ${offsetY}px)`,
        left: offsetX,
        zIndex: 1000,
        visibility: 'visible',
      });
    } else if (placement === 'top-start') {
      setStyle({
        position: 'absolute',
        bottom: `calc(100% + ${offsetY}px)`,
        left: offsetX,
        zIndex: 1000,
        visibility: 'visible',
      });
    } else if (placement === 'top-end') {
      setStyle({
        position: 'absolute',
        bottom: `calc(100% + ${offsetY}px)`,
        right: -offsetX,
        zIndex: 1000,
        visibility: 'visible',
      });
    }
  }, [open, offsetX, offsetY, placement]);

  if (!open) return null;

  return (
    <div className="popover-body" ref={anchorRef} style={style}>
      <div className="popover-container">
        <button className="popover-trigger">
          <FontAwesomeIcon icon={faInfoCircle} className="icon" />
        </button>

        <div className="popover-content">
          <div className="info-grid">
            <div>
              <h4 className="popover-title">{title}</h4>
              <p className="popover-description">{content}</p>
            </div>

            {/* <div className="info-grid">
              <div className="info-item">
                <span className="info-label">Project Name:</span>
                <span className="info-value">Website Redesign</span>
              </div>

              <div className="info-item">
                <span className="info-label">Status:</span>
                <span className="info-value">In Progress</span>
              </div>

              <div className="info-item">
                <span className="info-label">Deadline:</span>
                <span className="info-value">March 30, 2025</span>
              </div>

              <div className="info-item">
                <span className="info-label">Completion:</span>
                <span className="info-value">65%</span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Popover;
